import { PaymentElement } from '@stripe/react-stripe-js'
import React, { useMemo } from 'react'
import { StripePaymentElementOptions } from '@stripe/stripe-js'
import { Box, Palette, Typography } from '@mui/material'

export type StripePaymentElementProps = {
	setIsComplete: (complete: boolean) => void
	palette?: Palette
	message?: string | null
	sx?: any
}

export default function StripePaymentElement({ setIsComplete, message, sx }: StripePaymentElementProps) {
	const options = useMemo(
		() =>
			({
				layout: {
					type: 'accordion',
					defaultCollapsed: true,
					radios: false,
					spacedAccordionItems: false,
				},
			}) as StripePaymentElementOptions,
		[],
	)

	return (
		<Box sx={{ width: '100%', maxWidth: 500, mt: 2, mb: 2, ...sx }}>
			<PaymentElement options={options} onChange={(event) => setIsComplete(event.complete)} />
			{message && (
				<Typography color={message.includes('succeeded') ? 'success.main' : 'error'} mt={2}>
					{message}
				</Typography>
			)}
		</Box>
	)
}
